export const DamageTypes = [
    "Blitz",
    "Energie",
    "Feuer",
    "Gift",
    "Gleißend",
    "Hieb",
    "Kälte",
    "Nekrotisch",
    "Psychisch",
    "Säure",
    "Schall",
    "Stich",
    "Wucht"
]

export const DamageTypesByGroup = {
    "Waffen": ["Hieb", "Stich", "Wucht"],
    "Elementar": ["Feuer", "Kälte", "Blitz", "Schall", "Gift", "Säure"],
    "Magisch": ["Gleißend", "Nekrotisch", "Psychisch"]
}